import React from 'react'
import styled from 'styled-components'
import TestarImg from './testarImg'
import Line from './line'
import ButtonFlat from './buttonFlat'

const Container = styled.section` 
  display: grid;
  grid-template-columns: 553px 350px;
  justify-content: center;
  width: 100%;
  grid-gap: 60px;
 color: #24467E;
  @media( max-width: 972px){
    grid-template-columns: 1fr;
  }

  }
`

const Title = styled.h3`
  font-family: "Be Vietnam", sans-serif;
  margin-bottom: 27px;
  font-size: 29px;
  text-align: left !important;
  line-height: 40px;
  font-weight: 700;
  color: currentColor;
  /* strong {
    font-weight: bold;
  } */
  text-align: center;

  @media( max-width: 972px){
    text-align: center !important;

  }
`

const Description = styled.p`
  font-size: 0.8em;
  margin-top: 27px;
  font-weight: 300;
  color: currentColor;
  text-align: left !important;
  @media( max-width: 972px){
    text-align: center !important;
  }
`


const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    justify-self: center;
    text-align: center;
  a {
    max-width: 211px;
    @media( max-width: 972px){
      margin: 0 auto;
    }
  }
  @media( max-width: 972px){
    width: 374px;
    max-width:100%;
    height: 300px;
    align-items: center;
  }
`

const WrapperImg = styled.div`
   width: 100%;
   display: block;
   height: 443px;
   justify-self: center;
   
  @media( max-width: 972px){
    width: 374px;
    max-width:100%;
    height: 300px;
  }
   
   
`
const Testar = () => (
  <Container data-aos="fade-up" data-aos-duration="600">
   <WrapperImg>
    <TestarImg />
   </WrapperImg>
    <Wrapper>
      <Title>O TagPlus é o sistema de <br />
gestão online que sua <br />
empresa precisa!</Title>
      <Line align="flex-start"/>
      <Description>Participe do grupo exclusivo de clientes que <br/>
movimentam todo mês milhões de reais.</Description>
    <ButtonFlat anchor="https://tagplus.com.br/?ref=loja_aplicativos_banner_baixo" size="sm">Testar Grátis</ButtonFlat>
    </Wrapper>
   
  </Container>
)

export default Testar
